/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  createAccount(data) {
    return axios.post(`${this.apiVersion}/accounts`, data);
  }

  async getCacheKeys() {
    const response = await axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/cache_keys`
    );
    return response.data.cache_keys;
  }

  getAgentRestrictions() {
    return axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/agent_restrictions`
    );
  }

  updateAgentRestrictions(data) {
    return axios.patch(
      `/api/v1/accounts/${this.accountIdFromRoute}/update_agent_restrictions`,
      data
    );
  }
}

export default new AccountAPI();
